let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9OCf5")).then(() => parcelRequire('kcmYy'));